module.exports = __webpack_public_path__ + "static/crush-the-curve-light-mode-e5cf1d1fd7321637470742837eadc1b2.svg";